import { TagColorWithIntensity } from '@teetsh/app/src/styles/userConstants';

const PERIODE_COLORS: TagColorWithIntensity[] = [
  'miel-moderate',
  'limoncello-moderate',
  'amande-moderate',
  'kaki-moderate',
  'aloe-vera-moderate',
  'étang-moderate',
  'bleu-ciel-moderate',
  'gris-bleu-moderate',
  'lavande-moderate',
  'violine-moderate',
  'lila-moderate',
  'cassis-moderate',
  'barbapapa-moderate',
  'framboise-moderate',
  'mandarine-moderate',
  'taupe-moderate',
];

export function getPeriodeColor(index: number): TagColorWithIntensity {
  return PERIODE_COLORS[index % PERIODE_COLORS.length];
}

const DOMAINE_COLORS: TagColorWithIntensity[] = [
  'mandarine-quiet',
  'barbapapa-quiet',
  'lila-quiet',
  'lavande-quiet',
  'bleu-ciel-quiet',
  'aloe-vera-quiet',
  'amande-quiet',
  'miel-quiet',
  'limoncello-quiet',
  'kaki-quiet',
  'étang-quiet',
  'gris-bleu-quiet',
  'violine-quiet',
  'cassis-quiet',
  'framboise-quiet',
  'taupe-quiet',
];

export function getDomaineColor(index: number): TagColorWithIntensity {
  return DOMAINE_COLORS[index % DOMAINE_COLORS.length];
}
